<template>
  <b-row>
    <b-col cols="12">
      <h5 class="font-weight-bold">Status</h5>
      <div>
        <h4 class="d-flex align-items-center flex-wrap" style="gap: 10px">
          <b-badge
            :variant="
              status.includes(PAYMENT_PARTNER_STATUS.WAITING_CUSTOMER_PAYMENT)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(PAYMENT_PARTNER_STATUS.WAITING_CUSTOMER_PAYMENT)"
          >
            {{ getStatusText(PAYMENT_PARTNER_STATUS.WAITING_CUSTOMER_PAYMENT) }}
          </b-badge>
          
          <b-badge
            :variant="
              status.includes(PAYMENT_PARTNER_STATUS.WAITING_RETURN_DEADLINE)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(PAYMENT_PARTNER_STATUS.WAITING_RETURN_DEADLINE)"
          >
            {{ getStatusText(PAYMENT_PARTNER_STATUS.WAITING_RETURN_DEADLINE) }}
          </b-badge>
          
          <b-badge
            :variant="
              status.includes(PAYMENT_PARTNER_STATUS.REFUNDED) ? 'primary' : 'light'
            "
            class="pointer"
            @click="addStatus(PAYMENT_PARTNER_STATUS.REFUNDED)"
          >
            {{ getStatusText(PAYMENT_PARTNER_STATUS.REFUNDED) }}
          </b-badge>
          
          <b-badge
            :variant="
              status.includes(PAYMENT_PARTNER_STATUS.CANCELED)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(PAYMENT_PARTNER_STATUS.WAITING_TRANSFER_PARTNER)"
          >
            {{ getStatusText(PAYMENT_PARTNER_STATUS.WAITING_TRANSFER_PARTNER) }}
          </b-badge>
          
          <b-badge
            :variant="
              status.includes(PAYMENT_PARTNER_STATUS.CANCELED)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(PAYMENT_PARTNER_STATUS.CANCELED)"
          >
            {{ getStatusText(PAYMENT_PARTNER_STATUS.CANCELED) }}
          </b-badge>
          
          <b-badge
            :variant="
              status.includes(PAYMENT_PARTNER_STATUS.PAID_PARTNER)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(PAYMENT_PARTNER_STATUS.PAID_PARTNER)"
          >
            {{ getStatusText(PAYMENT_PARTNER_STATUS.PAID_PARTNER) }}
          </b-badge>
          <b-badge
            :variant="
              status.length === Object.keys(PAYMENT_PARTNER_STATUS).length
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addAllStatus()"
          >
            Todos
          </b-badge>
        </h4>
      </div>
    </b-col>
  </b-row>  
</template>

<script>
import { mapLabel } from '@/enums/Partner/PaymentPartnerStatus';
import PAYMENT_PARTNER_STATUS from '@/enums/Partner/PaymentPartnerStatus';

export default {
  name:'StatusFilter',

  data() {
    return {
      loading: false,
      status: [],
      PAYMENT_PARTNER_STATUS
    }
  },

  methods: {
    // ...mapActions('shopkeeper', ['getAllPartners']),

    addStatus(userType) {
      if (this.status.includes(userType)) {
        const index = this.status.indexOf(userType);
        this.status.splice(index, 1);
        // this.list();
        return;
      }

      // this.fields.status.push(userType);
      // this.list();
    },
    getStatusText(status) {
      return mapLabel(status);
    },
    addAllStatus() {
      Object.values(PAYMENT_PARTNER_STATUS).forEach((value) => {
        if (this.status.includes(value)) return;

        this.status.push(value);
      });

      // this.list();
      // dar um emit
    },
  },
}

</script>